import { render, staticRenderFns } from "./BookFilters.vue?vue&type=template&id=43b56329&scoped=true&"
import script from "./BookFilters.vue?vue&type=script&lang=ts&"
export * from "./BookFilters.vue?vue&type=script&lang=ts&"
import style0 from "./BookFilters.vue?vue&type=style&index=0&id=43b56329&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b56329",
  null
  
)

export default component.exports